module.exports = __webpack_public_path__ + "851df4aaccf51592a51a9c1bcb58c925.pdf";